/**
 * Test-Aufgabe-Model
 * @class service_v3sTestItem
 * @memberOf v3sWbtPlayerApp:model
 * @extends v3sWbtPlayerApp:model.service_v3sItem
 */
angular.module('v3sWbtPlayerApp').factory('v3sTestItem', ["v3sItem", "v3sExerciseTest", function (v3sItem, v3sExerciseTest) {

    // instantiate the sco object
    var v3sTestItem = function (data, options) {
        // use the original item object constructor
        v3sItem.apply(this, arguments);

        this.ScormDataEnum.NEW_TEST_DATA = 0;

        this.type = "exercise";
        this.statistic = "";
        this.selected = false;
        this.evaluated = false;
        this.reviewed = false;
    };

    // use the original v3sSco prototype
    v3sTestItem.prototype = new v3sItem();

    /**
    * Gibt Test zurück.
    * @memberOf v3sWbtPlayerApp:model.service_v3sTestItem
    */
    v3sTestItem.prototype.getTest = function () {
        return this.parent.getTest();
    };

    v3sTestItem.prototype.getParent = function () {
        var parent = null;

        var test = this.getTest();
        if (test.isReview()) {
            parent = this.parent;
        } else {
            parent = test;
        }

        return parent;
    };

    v3sTestItem.prototype.complete = function () {
        if (!this.isCompleted() && this.isSelected()) {
            v3sItem.prototype.complete.call(this);

            var testConfig = this.getTest().getConfig();
            if (testConfig.evaluateAllSelected || (!!this.exercise && this.exercise.isCompleted())) {
                if (!this.exercise || !this.exercise.isCompleted()) {
                    this.evaluate(0);
                }

                if (!!testConfig.pots) {
                    if (this.isLastPassed()) {
                        this.statistic += "1";
                    } else {
                        this.statistic += "0";
                    }
                }
            }
        }
    };

    v3sTestItem.prototype.evaluate = function (score) {
        if (this.isTrackable()) {
            this.score = score;
            this.evaluated = true;
            this.notifyPageChanged();
        }
    };

    v3sTestItem.prototype.isEvaluated = function () {
        return this.evaluated;
    };

    v3sTestItem.prototype.isLastEvaluated = function () {
        return this.evaluated;
    };

    v3sTestItem.prototype.reset = function () {
        this.score = 0;
        this.exercise = null;
        this.status = "incomplete";
        this.selected = false;
        this.evaluated = false;
    };

    v3sTestItem.prototype.select = function (selected) {
        this.selected = selected !== false;

        if (this.selected) {
            this.parent.addToSelectedExercises(this);
        }
    };

    v3sTestItem.prototype.isSelected = function () {
        return this.selected;
    };

    v3sTestItem.prototype.hasStatistic = function (regexp) {
        var result = false;
        if (!!regexp && typeof regexp.test === "function") {
            result = regexp.test(this.statistic);
        }
        //console.log(this.title +" " + regexp + "->[" +this.statistic + "]: " + result);
        return result;
    };

    v3sTestItem.prototype.getStatus = function () {
        var status = this.selected ? "" : " not-selected-in-test";

        if (this.evaluated) {
            status += v3sItem.prototype.getStatus.call(this);
        } else {
            status += "incomplete";
        }

        return status;
    };

    v3sTestItem.prototype.getStatistic = function (pots) {
        var self = this;
        if (!!pots.exercises) {
            pots.exercises.count++;
        }

        if (!!this.statistic) {
            if (!!pots.evaluated) {
                pots.evaluated.count++;
            }
            if (!!pots.evaluationTries) {
                pots.evaluationTries.count += this.statistic.length;
            }
        }

        angular.forEach(pots, function (pot) {
            if (!!pot.regexp && self.hasStatistic(pot.regexp)) {
                pot.count++;
            }
        });
    };

    v3sTestItem.prototype.getNumberOfTries = function () {
        return this.statistic.length;
    };

    v3sTestItem.prototype.getExercise = function () {
        return this.exercise;
    };

    v3sTestItem.prototype.initExercise = function (data) {
        if (!this.exercise) {
            this.exercise = new v3sExerciseTest(this, data, this.getTest().getConfig());
        }
        this.exercise.init();
        return this.exercise;
    };

    v3sTestItem.prototype.clean = function () {
        if (!!this.exercise) {
            this.exercise.clean();
        }
    };

    v3sTestItem.prototype.getScormData = function () {
        //obsolete
    };

    v3sTestItem.prototype.setScormData = function (data) {
        //obsolete, wird nur für das Holen der alten Daten benutzt
        if (!!data) {
            this.statistic += data;
        }
    };

    v3sTestItem.prototype.getGlobalScormData = function (data) {
        if (!!data) {
            var scormData = [];

            if (this.statistic.length > 0) {
                scormData[this.ScormDataEnum.NEW_TEST_DATA] = formatStatisticToNumber(this.statistic);
            }

            if (scormData.length > 0) {
                data[this.id] = scormData;
            }
        }
    };

    v3sTestItem.prototype.setGlobalScormData = function (data) {
        if (!!data && !!data[this.id] && data[this.id].length > 0) {

            if (data[this.id].length == 1) {
                this.statistic = formatStatisticToString(data[this.id][this.ScormDataEnum.NEW_TEST_DATA]);
            } else {
                this.statistic = data[this.id][this.ScormDataEnum.TEST_DATA];
            }
        }
    };

    /**
     * Gibt zurück, ob die Aufgabe im Reviewmodus angesehen wurde
     * @memberOf v3sWbtPlayerApp:model.service_v3sTestItem
     * @return {bool} 
     */
    v3sTestItem.prototype.isReviewed = function () {
        return this.reviewed;
    };

    /**
     * Setzt, ob die Aufgabe im Reviewmodus angesehen wurde
     * @memberOf v3sWbtPlayerApp:model.service_v3sTestItem
     */
    v3sTestItem.prototype.setReviewed = function (reviewed) {
        this.reviewed = reviewed;
    };

    v3sTestItem.prototype.changeProperties = function () {
        //deaktivieren
    };

    function formatStatisticToString(statistic) {
        var strStatistic = "";

        if (!!statistic || statistic === 0) {
            if (typeof statistic == 'number') {
                switch (statistic) {
                    case 0:
                        strStatistic = "0";
                        break;
                    case 1:
                        strStatistic = "1";
                        break;
                    case 2:
                        strStatistic = "10";
                        break;
                    case 5:
                        strStatistic = "01";
                        break;
                    default:
                        strStatistic = "0";
                }
            } else if (typeof statistic == 'string') { //old format
                strStatistic = statistic;
            }
        }

        return strStatistic;
    };

    function formatStatisticToNumber(strStatistic) {
        var nStatistic = undefined;

        if (strStatistic.length > 0) {
            var lastChar = strStatistic.slice(-1);
            var remainStr = strStatistic.slice(0, -1);
            if (lastChar == "1") {
                nStatistic = remainStr.indexOf("0") >= 0 ? 5 : 1;
            } else {//0
                nStatistic = remainStr.indexOf("1") >= 0 ? 2 : 0;
            }
        }
        return nStatistic;
    };

    return v3sTestItem;
}]);


